import * as v from 'valibot';

export const setupValibotI18n = (): void => {
  v.setGlobalMessage('Невірне значення.');
  v.setSchemaMessage('Поле обов\'язкове.');

  v.setSpecificMessage(v.string, 'Поле обов\'язкове.');
  v.setSpecificMessage(v.number, 'Очікується число.');
  v.setSpecificMessage(v.boolean, 'Очікується булеве значення.');
  v.setSpecificMessage(v.bigint, 'Очікується велике число.');
  v.setSpecificMessage(v.date, 'Очікується дата.');
  v.setSpecificMessage(v.array, 'Очікується масив.');
  v.setSpecificMessage(v.object, 'Очікується об\'єкт.');
  v.setSpecificMessage(v.literal, 'Невірне значення.');
  v.setSpecificMessage(v.picklist, 'Оберіть значення зі списку.');
  v.setSpecificMessage(v.enum, 'Невірне значення.');
  v.setSpecificMessage(v.union, 'Невірне значення.');

  v.setSpecificMessage(v.nonEmpty, 'Поле обов\'язкове.');
  v.setSpecificMessage(v.email, 'Невірна адреса електронної пошти.');
  v.setSpecificMessage(v.url, 'Невірне посилання.');
  v.setSpecificMessage(v.uuid, 'Невірний UUID.');
  v.setSpecificMessage(v.integer, 'Очікується ціле число.');
  v.setSpecificMessage(v.regex, 'Значення не відповідає шаблону.');
  v.setSpecificMessage(v.isoDate, 'Невірна дата.');
  v.setSpecificMessage(v.isoDateTime, 'Невірна дата та час.');
  v.setSpecificMessage(v.isoTime, 'Невірний час.');

  v.setSpecificMessage(
    v.minLength,
    (issue) => `Мінімальна довжина — ${issue.requirement} символів.`,
  );
  v.setSpecificMessage(
    v.maxLength,
    (issue) => `Максимальна довжина — ${issue.requirement} символів.`,
  );
  v.setSpecificMessage(
    v.length,
    (issue) => `Довжина має бути ${issue.requirement} символів.`,
  );
  v.setSpecificMessage(
    v.minValue,
    (issue) => `Мінімальне значення — ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.maxValue,
    (issue) => `Максимальне значення — ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.minSize,
    (issue) => `Мінімальна кількість елементів — ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.maxSize,
    (issue) => `Максимальна кількість елементів — ${issue.requirement}.`,
  );
};
